import { Navigate, Outlet } from 'react-router-dom';
import { PatientPortalButton } from '@/components/patient-portal/PatientPortalButton';
import { PatientPortalLayout } from '@/components/patient-portal/PatientPortalLayout';
import { PageLoader } from '@/components/ui/PageLoader';
import {
  PatientAuthProvider,
  usePatientAuth,
} from '@/contexts/PatientAuthContext';
import { PATIENT_SIGN_IN_PATH } from '@/lib/patientPortalApi';

function PatientSessionGate() {
  const { state, reload, signOut, signOutError } = usePatientAuth();

  switch (state.status) {
    case 'loading':
      return <PageLoader />;
    case 'none':
      return <Navigate to={PATIENT_SIGN_IN_PATH} replace />;
    case 'staff':
      return (
        <PatientPortalLayout>
          <h1 className="text-patient-title">You are signed in as staff</h1>
          <p className="mt-2 text-base leading-6">
            These pages are for patients. Sign out to continue.
          </p>
          <PatientPortalButton className="mt-6" onClick={signOut}>
            Sign out
          </PatientPortalButton>
        </PatientPortalLayout>
      );
    case 'error':
      return (
        <PatientPortalLayout>
          <h1 className="text-patient-title">We could not load your account</h1>
          <p className="mt-2 text-base leading-6">
            Check your connection and try again.
          </p>
          <PatientPortalButton className="mt-6" onClick={reload}>
            Try again
          </PatientPortalButton>
        </PatientPortalLayout>
      );
    case 'patient':
      return (
        <PatientPortalLayout
          wide
          onSignOut={signOut}
          signOutError={signOutError}
        >
          <Outlet />
        </PatientPortalLayout>
      );
  }
}

/**
 * The patient pages' session: outside SessionScope, so the staff provider and
 * its clinic calls never run here. App.test.tsx pins the split.
 */
export function PatientSessionScope() {
  return (
    <PatientAuthProvider>
      <PatientSessionGate />
    </PatientAuthProvider>
  );
}
